// extracted by mini-css-extract-plugin
export default {"container":"JsonEditorContainer__container___lA_Vd"};